import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ORIGIN = 'https://perashoot.com';
const META = {
  '/': {
    title: 'Financial Modeling for Founders | perashoot',
    description: 'Build an accurate, investor-ready financial model without spreadsheet expertise. Plan runway, taxes, scenarios and SaaS metrics with perashoot.',
  },
  '/privacy': {
    title: 'Privacy Policy | perashoot',
    description: 'Learn what perashoot collects, how financial model data is used and secured, and how to request access, export or deletion.',
  },
  '/terms': {
    title: 'Terms of Service | perashoot',
    description: 'Read the terms that govern use of the perashoot financial modeling platform.',
  },
};

function setMeta(selector, attribute, value) {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement(selector.startsWith('link') ? 'link' : 'meta');
    const match = selector.match(/\[(name|property|rel)="([^"]+)"\]/);
    if (match) element.setAttribute(match[1], match[2]);
    document.head.appendChild(element);
  }
  element.setAttribute(attribute, value);
}

export default function SeoAnalytics() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = META[pathname] || META['/'];
    const canonical = `${ORIGIN}${pathname === '/' ? '/' : pathname}`;
    document.title = meta.title;
    setMeta('meta[name="description"]', 'content', meta.description);
    setMeta('link[rel="canonical"]', 'href', canonical);
    setMeta('meta[property="og:title"]', 'content', meta.title);
    setMeta('meta[property="og:description"]', 'content', meta.description);
    setMeta('meta[property="og:url"]', 'content', canonical);
    setMeta('meta[property="og:image"]', 'content', `${ORIGIN}/social-card.svg`);
    setMeta('meta[name="twitter:image"]', 'content', `${ORIGIN}/social-card.svg`);

    let schema = document.getElementById('route-schema');
    if (!schema) {
      schema = document.createElement('script');
      schema.id = 'route-schema';
      schema.type = 'application/ld+json';
      document.head.appendChild(schema);
    }
    schema.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': pathname === '/' ? 'SoftwareApplication' : 'WebPage',
      name: meta.title,
      description: meta.description,
      url: canonical,
      ...(pathname === '/' ? { applicationCategory: 'FinanceApplication', operatingSystem: 'Web' } : {}),
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'page_view', page_path: pathname, page_location: canonical, page_title: meta.title });
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', { page_path: pathname, page_location: canonical, page_title: meta.title });
    }
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
